// import React, { useState, useEffect } from "react";
// import { AiOutlineEdit } from "react-icons/ai";
// import {
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableHead,
// 	TableHeader,
// 	TableRow,
// } from "../components/ui/table";
// import { useNavigate } from "react-router-dom";
// import { useToast } from "../components/ui/use-toast";
// import { ClipLoader } from "react-spinners";
// import {
// 	Dialog,
// 	DialogContent,
// 	DialogDescription,
// 	DialogHeader,
// } from "../components/ui/dialog";
// import {
// 	Select,
// 	SelectContent,
// 	SelectItem,
// 	SelectTrigger,
// 	SelectValue,
// } from "../components/ui/select";
// import LocationForm from "../components/LocationForm";
// import useAuth from "../hooks/useAuth";
// import { useCheckClientLocations, useGetAllClients, useGetClientLocations } from "../migration-api/api-hooks/clients";

// function ClientLocations() {
// 	const [open, setOpen] = useState(false);
// 	const navigate = useNavigate();
// 	const { toast } = useToast();
// 	const { auth } = useAuth();

// 	const [clientLocations, setClientLocations] = useState([]);
// 	const [localLocation, setLocalLocation] = useState(null);
// 	const [selectedClientEmail, setSelectedClientEmail] = useState("");

// 	const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
// 	const isAdmin = auth?.user?.role !== "SUPER_ADMIN";
// 	const clientId = auth?.user?.clientId;

// 	// Fetch all clients for super admin
// 	const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients({
// 		enabled: isSuperAdmin,
// 		onError: (error) => {
// 			toast({
// 				variant: "destructive",
// 				title: "Error",
// 				description: "Failed to fetch clients",
// 			});
// 		},
// 	});

// 	// Use the custom hook for checking client locations
// 	const { checkClientLocations, isLoading: isLoadingLocations } = useGetClientLocations(
// 		isAdmin ? clientId : selectedClientId, {
// 		enabled: (isAdmin && !!clientId) || (isSuperAdmin && !!selectedClientId),	
// 		onSuccess: (data) => {
// 			const locations = data?.data || [];
// 			setClientLocations(locations);

// 			if (locations.length === 0) {
// 				toast({
// 					title: "No Locations Found",
// 					description: "This client has no locations available.",
// 				});
// 			}
// 		},
// 		onError: (error) => {
// 			// Clear the locations when error occurs
// 			setClientLocations([]);

// 			if (error.code === "ERR_NETWORK") {
// 				navigate("/", { replace: true });
// 			} else if (
// 				error.response?.status === 401 ||
// 				error.response?.status === 403
// 			) {
// 				navigate("/", { replace: true });
// 			} else {
// 				toast({
// 					variant: "destructive",
// 					title: "Error",
// 					description:
// 						error?.response?.data?.message || "Failed to fetch locations",
// 				});
// 			}
// 		},
// 	});

// 	// Auto-select first client for SUPER_ADMIN when clients are loaded
// 	useEffect(() => {
// 		const clients = clientsData?.data || [];
// 		if (isSuperAdmin && clients.length > 0 && !selectedClientEmail) {
// 			const firstClient = clients[0];
// 			setSelectedClientEmail(firstClient.email);
// 			checkClientLocations({ client_email: firstClient.email });
// 		}
// 	}, [isSuperAdmin, clientsData, selectedClientEmail]);

// 	// Fetch locations on component mount for ADMIN users
// 	useEffect(() => {
// 		if (isAdmin && auth?.user?.email) {
// 			checkClientLocations({ client_email: auth.user.email });
// 		}
// 	}, [isAdmin, auth?.user?.email]);

// 	// Handle client selection for SUPER_ADMIN
// 	const handleClientSelect = (clientEmail) => {
// 		setSelectedClientEmail(clientEmail);
// 		setClientLocations([]); // Clear previous locations
// 		checkClientLocations({ client_email: clientEmail });
// 	};

// 	// Handle opening edit dialog
// 	const handleOpen = (locationData) => {
// 		setOpen(true);
// 		const clientEmail = isSuperAdmin ? selectedClientEmail : auth?.user?.email;

// 		setLocalLocation({
// 			...locationData,
// 			client_email: clientEmail,
// 		});
// 	};

// 	// Refresh locations after update
// 	const handleComplete = () => {
// 		setOpen(false);
// 		const clientEmail = isSuperAdmin ? selectedClientEmail : auth?.user?.email;

// 		if (clientEmail) {
// 			checkClientLocations({ client_email: clientEmail });
// 		}
// 	};

// 	const clients = clientsData?.data || [];

// 	// Show loading state while fetching clients for super admin
// 	if (isSuperAdmin && isLoadingClients) {
// 		return (
// 			<div className="flex items-center justify-center p-12">
// 				<div className="text-center">
// 					<ClipLoader color="primary" size={50} />
// 					<p className="mt-4 text-gray-600">Loading clients...</p>
// 				</div>
// 			</div>
// 		);
// 	}

// 	return (
// 		<section>
// 			<div>
// 				{/* Client Selection for SUPER_ADMIN */}
// 				{isSuperAdmin && (
// 					<div className="mb-6">
// 						<label className="block text-sm font-medium mb-2">
// 							Select Client
// 						</label>
// 						<Select
// 							value={selectedClientEmail}
// 							onValueChange={handleClientSelect}
// 						>
// 							<SelectTrigger className="w-full max-w-md">
// 								<SelectValue placeholder="Select a client to view locations" />
// 							</SelectTrigger>
// 							<SelectContent>
// 								{clients.length > 0 ? (
// 									clients.map((client) => (
// 										<SelectItem
// 											key={client.id}
// 											value={client.email}
// 										>
// 											{client.company_name || client.email}
// 										</SelectItem>
// 									))
// 								) : (
// 									<SelectItem value="no-clients" disabled>
// 										No clients available
// 									</SelectItem>
// 								)}
// 							</SelectContent>
// 						</Select>
// 					</div>
// 				)}

// 				<div className="relative">
// 					{isLoadingLocations ? (
// 						<div className="p-[40px] h-[20vh] place-content-center text-center z-50">
// 							<ClipLoader color="primary" size={35} />
// 							<p>Loading locations</p>
// 						</div>
// 					) : (
// 						<section className="mt-7">
// 							<Table>
// 								<TableHeader>
// 									<TableRow>
// 										<TableHead>Address</TableHead>
// 										<TableHead className="text-center">
// 											GLN
// 										</TableHead>
// 										<TableHead className="text-center">
// 											Latitude
// 										</TableHead>
// 										<TableHead className="text-center">
// 											Longitude
// 										</TableHead>
// 										<TableHead>Action</TableHead>
// 									</TableRow>
// 								</TableHeader>
// 								<TableBody>
// 									{clientLocations?.length > 0 ? (
// 										clientLocations.map((location, i) => (
// 											<TableRow key={location.gln || i}>
// 												<TableCell>
// 													{location.address}
// 												</TableCell>
// 												<TableCell className="text-center">
// 													{location.gln}
// 												</TableCell>
// 												<TableCell className="text-center">
// 													{location.latitude}
// 												</TableCell>
// 												<TableCell className="text-center">
// 													{location.longitude}
// 												</TableCell>
// 												<TableCell>
// 													<button
// 														onClick={() => handleOpen(location)}
// 														className="flex items-center gap-1 text-primary hover:underline"
// 													>
// 														<AiOutlineEdit /> edit
// 													</button>
// 												</TableCell>
// 											</TableRow>
// 										))
// 									) : (
// 										<TableRow>
// 											<TableCell colSpan={5}>
// 												<h1 className="text-center h-[20vh] place-content-center text-gray-500">
// 													{isSuperAdmin && clients.length === 0
// 														? "No clients available"
// 														: "NO LOCATIONS FOUND"}
// 												</h1>
// 											</TableCell>
// 										</TableRow>
// 									)}
// 								</TableBody>
// 							</Table>
// 						</section>
// 					)}
// 				</div>
// 			</div>

// 			<Dialog open={open} onOpenChange={setOpen}>
// 				<DialogContent className="max-w-xl">
// 					<DialogHeader>
// 						<DialogDescription>
// 							<LocationForm
// 								locationData={localLocation}
// 								isOnboarding={false}
// 								onComplete={handleComplete}
// 							/>
// 						</DialogDescription>
// 					</DialogHeader>
// 				</DialogContent>
// 			</Dialog>
// 		</section>
// 	);
// }

// export default ClientLocations;




// import React, { useState, useEffect } from "react";
// import { AiOutlineEdit } from "react-icons/ai";
// import {
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableHead,
// 	TableHeader,
// 	TableRow,
// } from "../components/ui/table";
// import { useNavigate } from "react-router-dom";
// import { useToast } from "../components/ui/use-toast";
// import { ClipLoader } from "react-spinners";
// import {
// 	Dialog,
// 	DialogContent,
// 	DialogDescription,
// 	DialogHeader,
// } from "../components/ui/dialog";
// import {
// 	Select,
// 	SelectContent,
// 	SelectItem,
// 	SelectTrigger,
// 	SelectValue,
// } from "../components/ui/select";
// import LocationForm from "../components/LocationForm";
// import useAuth from "../hooks/useAuth";
// import { useGetAllClients, useGetClientLocations } from "../migration-api/api-hooks/clients";

// function ClientLocations() {
// 	const [open, setOpen] = useState(false);
// 	const navigate = useNavigate();
// 	const { toast } = useToast();
// 	const { auth } = useAuth();

// 	const [clientLocations, setClientLocations] = useState([]);
// 	const [localLocation, setLocalLocation] = useState(null);
// 	const [selectedClientId, setSelectedClientId] = useState("");

// 	const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
// 	const isAdmin = auth?.user?.role !== "SUPER_ADMIN";
// 	const clientId = auth?.user?.clientId;

// 	// Fetch all clients for super admin
// 	const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients({}, {
// 		enabled: isSuperAdmin,
// 		onError: (error) => {
// 			toast({
// 				variant: "destructive",
// 				title: "Error",
// 				description: "Failed to fetch clients",
// 			});
// 		},
// 	});

// 	// Use the custom hook for checking client locations
// 	const { data: locationsData, isLoading: isLoadingLocations, refetch: refetchLocations } = useGetClientLocations(
// 		isAdmin ? clientId : selectedClientId,
// 		{
// 			enabled: (isAdmin && !!clientId) || (isSuperAdmin && !!selectedClientId),	
// 			onSuccess: (data) => {
// 				const locations = data?.data || [];
// 				setClientLocations(locations);

// 				if (locations.length === 0) {
// 					toast({
// 						title: "No Locations Found",
// 						description: "This client has no locations available.",
// 					});
// 				}
// 			},
// 			onError: (error) => {
// 				// Clear the locations when error occurs
// 				setClientLocations([]);

// 				if (error.code === "ERR_NETWORK") {
// 					navigate("/", { replace: true });
// 				} else if (
// 					error.response?.status === 401 ||
// 					error.response?.status === 403
// 				) {
// 					navigate("/", { replace: true });
// 				} else {
// 					toast({
// 						variant: "destructive",
// 						title: "Error",
// 						description:
// 							error?.response?.data?.message || "Failed to fetch locations",
// 					});
// 				}
// 			},
// 		}
// 	);

// 	// Auto-select first client for SUPER_ADMIN when clients are loaded
// 	useEffect(() => {
// 		const clients = clientsData?.data || [];
// 		if (isSuperAdmin && clients.length > 0 && !selectedClientId) {
// 			const firstClient = clients[0];
// 			setSelectedClientId(firstClient.id);
// 		}
// 	}, [isSuperAdmin, clientsData, selectedClientId]);

// 	// Handle client selection for SUPER_ADMIN
// 	const handleClientSelect = (clientId) => {
// 		setSelectedClientId(clientId);
// 		setClientLocations([]); // Clear previous locations
// 	};

// 	// Refetch when selectedClientId changes
// 	useEffect(() => {
// 		if (selectedClientId) {
// 			refetchLocations();
// 		}
// 	}, [selectedClientId, refetchLocations]);

// 	// Handle opening edit dialog
// 	const handleOpen = (locationData) => {
// 		setOpen(true);
// 		const currentClientId = isSuperAdmin ? selectedClientId : clientId;

// 		setLocalLocation({
// 			...locationData,
// 			client_id: currentClientId,
// 		});
// 	};

// 	// Refresh locations after update
// 	const handleComplete = () => {
// 		setOpen(false);
// 		refetchLocations();
// 	};

// 	const clients = clientsData?.data || [];

// 	// Show loading state while fetching clients for super admin
// 	if (isSuperAdmin && isLoadingClients) {
// 		return (
// 			<div className="flex items-center justify-center p-12">
// 				<div className="text-center">
// 					<ClipLoader color="primary" size={50} />
// 					<p className="mt-4 text-gray-600">Loading clients...</p>
// 				</div>
// 			</div>
// 		);
// 	}

// 	return (
// 		<section>
// 			<div>
// 				{/* Client Selection for SUPER_ADMIN */}
// 				{isSuperAdmin && (
// 					<div className="mb-6">
// 						<label className="block text-sm font-medium mb-2">
// 							Select Client
// 						</label>
// 						<Select
// 							value={selectedClientId}
// 							onValueChange={handleClientSelect}
// 						>
// 							<SelectTrigger className="w-full max-w-md">
// 								<SelectValue placeholder="Select a client to view locations" />
// 							</SelectTrigger>
// 							<SelectContent>
// 								{clients.length > 0 ? (
// 									clients.map((client) => (
// 										<SelectItem
// 											key={client.id}
// 											value={client.id}
// 										>
// 											{client.company_name || client.email}
// 										</SelectItem>
// 									))
// 								) : (
// 									<SelectItem value="no-clients" disabled>
// 										No clients available
// 									</SelectItem>
// 								)}
// 							</SelectContent>
// 						</Select>
// 					</div>
// 				)}

// 				<div className="relative">
// 					{isLoadingLocations ? (
// 						<div className="p-[40px] h-[20vh] place-content-center text-center z-50">
// 							<ClipLoader color="primary" size={35} />
// 							<p>Loading locations</p>
// 						</div>
// 					) : (
// 						<section className="mt-7">
// 							<Table>
// 								<TableHeader>
// 									<TableRow>
// 										<TableHead>Address</TableHead>
// 										<TableHead className="text-center">
// 											GLN
// 										</TableHead>
// 										<TableHead className="text-center">
// 											Latitude
// 										</TableHead>
// 										<TableHead className="text-center">
// 											Longitude
// 										</TableHead>
// 										<TableHead>Action</TableHead>
// 									</TableRow>
// 								</TableHeader>
// 								<TableBody>
// 									{clientLocations?.length > 0 ? (
// 										clientLocations.map((location, i) => (
// 											<TableRow key={location.gln || i}>
// 												<TableCell>
// 													{location.address}
// 												</TableCell>
// 												<TableCell className="text-center">
// 													{location.gln}
// 												</TableCell>
// 												<TableCell className="text-center">
// 													{location.latitude}
// 												</TableCell>
// 												<TableCell className="text-center">
// 													{location.longitude}
// 												</TableCell>
// 												<TableCell>
// 													<button
// 														onClick={() => handleOpen(location)}
// 														className="flex items-center gap-1 text-primary hover:underline"
// 													>
// 														<AiOutlineEdit /> edit
// 													</button>
// 												</TableCell>
// 											</TableRow>
// 										))
// 									) : (
// 										<TableRow>
// 											<TableCell colSpan={5}>
// 												<h1 className="text-center h-[20vh] place-content-center text-gray-500">
// 													{isSuperAdmin && clients.length === 0
// 														? "No clients available"
// 														: "NO LOCATIONS FOUND"}
// 												</h1>
// 											</TableCell>
// 										</TableRow>
// 									)}
// 								</TableBody>
// 							</Table>
// 						</section>
// 					)}
// 				</div>
// 			</div>

// 			<Dialog open={open} onOpenChange={setOpen}>
// 				<DialogContent className="max-w-xl">
// 					<DialogHeader>
// 						<DialogDescription>
// 							<LocationForm
// 								locationData={localLocation}
// 								isOnboarding={false}
// 								onComplete={handleComplete}
// 							/>
// 						</DialogDescription>
// 					</DialogHeader>
// 				</DialogContent>
// 			</Dialog>
// 		</section>
// 	);
// }

// export default ClientLocations;




import React, { useState, useEffect } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "../components/ui/table";
import { useNavigate } from "react-router-dom";
import { useToast } from "../components/ui/use-toast";
import { ClipLoader } from "react-spinners";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
} from "../components/ui/dialog";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../components/ui/select";
import LocationForm from "../components/LocationForm";
import useAuth from "../hooks/useAuth";
import { useGetAllClients, useGetClientLocations } from "../migration-api/api-hooks/clients";

function ClientLocations() {
	const [open, setOpen] = useState(false);
	const navigate = useNavigate();
	const { toast } = useToast();
	const { auth } = useAuth();

	const [clientLocations, setClientLocations] = useState([]);
	const [localLocation, setLocalLocation] = useState(null);
	const [selectedClientId, setSelectedClientId] = useState("");
	const [isInitialLoad, setIsInitialLoad] = useState(true);

	const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
	const isAdmin = auth?.user?.role !== "SUPER_ADMIN";
	const clientId = auth?.user?.clientId;

	// Fetch all clients for super admin
	const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients({}, {
		enabled: isSuperAdmin,
		onError: (error) => {
			toast({
				variant: "destructive",
				title: "Error",
				description: "Failed to fetch clients",
			});
		},
	});

	// Use the custom hook for checking client locations
	const { data: locationsData, isLoading: isLoadingLocations, isFetching: isFetchingLocations, refetch: refetchLocations } = useGetClientLocations(
		isAdmin ? clientId : selectedClientId,
		{
			enabled: (isAdmin && !!clientId) || (isSuperAdmin && !!selectedClientId),	
			onSuccess: (data) => {
				const locations = data?.data || [];
				setClientLocations(locations);
				setIsInitialLoad(false);

				if (locations.length === 0) {
					toast({
						title: "No Locations Found",
						description: "This client has no locations available.",
					});
				}
			},
			onError: (error) => {
				// Clear the locations when error occurs
				setClientLocations([]);
				setIsInitialLoad(false);

				if (error.code === "ERR_NETWORK") {
					navigate("/", { replace: true });
				} else if (
					error.response?.status === 401 ||
					error.response?.status === 403
				) {
					navigate("/", { replace: true });
				} else {
					toast({
						variant: "destructive",
						title: "Error",
						description:
							error?.response?.data?.message || "Failed to fetch locations",
					});
				}
			},
		}
	);

	// Auto-select first client for SUPER_ADMIN when clients are loaded
	useEffect(() => {
		const clients = clientsData?.data || [];
		if (isSuperAdmin && clients.length > 0 && !selectedClientId) {
			const firstClient = clients[0];
			setSelectedClientId(firstClient.id);
		}
	}, [isSuperAdmin, clientsData, selectedClientId]);

	// Handle client selection for SUPER_ADMIN
	const handleClientSelect = (clientId) => {
		setSelectedClientId(clientId);
		setClientLocations([]); // Clear previous locations
		setIsInitialLoad(true); // Set loading state for new client
	};

	// Refetch when selectedClientId changes
	useEffect(() => {
		if (selectedClientId) {
			refetchLocations();
		}
	}, [selectedClientId, refetchLocations]);

	// Handle opening edit dialog
	const handleOpen = (locationData) => {
		setOpen(true);
		const currentClientId = isSuperAdmin ? selectedClientId : clientId;

		setLocalLocation({
			...locationData,
			client_id: currentClientId,
		});
	};

	// Refresh locations after update
	const handleComplete = () => {
		setOpen(false);
		refetchLocations();
	};

	const clients = clientsData?.data || [];

	// Comprehensive loading state that handles all scenarios
	const showLoading = 
		isLoadingClients || 
		isLoadingLocations || 
		isFetchingLocations || 
		isInitialLoad ||
		(isSuperAdmin && !selectedClientId) ||
		(isAdmin && !clientId);

	// Show loading state while fetching clients for super admin
	if (isSuperAdmin && isLoadingClients) {
		return (
			<div className="flex items-center justify-center p-12">
				<div className="text-center">
					<ClipLoader color="primary" size={50} />
					<p className="mt-4 text-gray-600">Loading clients...</p>
				</div>
			</div>
		);
	}

	return (
		<section>
			<div>
				{/* Client Selection for SUPER_ADMIN */}
				{isSuperAdmin && (
					<div className="mb-6">
						<label className="block text-sm font-medium mb-2">
							Select Client
						</label>
						<Select
							value={selectedClientId}
							onValueChange={handleClientSelect}
						>
							<SelectTrigger className="w-full max-w-md">
								<SelectValue placeholder="Select a client to view locations" />
							</SelectTrigger>
							<SelectContent>
								{clients.length > 0 ? (
									clients.map((client) => (
										<SelectItem
											key={client.id}
											value={client.id}
										>
											{client.company_name || client.email}
										</SelectItem>
									))
								) : (
									<SelectItem value="no-clients" disabled>
										No clients available
									</SelectItem>
								)}
							</SelectContent>
						</Select>
					</div>
				)}

				<div className="relative">
					{showLoading ? (
						<div className="p-[40px] h-[20vh] place-content-center text-center z-50">
							<ClipLoader color="primary" size={35} />
							<p>Loading locations</p>
						</div>
					) : (
						<section className="mt-7">
							<Table>
								<TableHeader>
									<TableRow>
										<TableHead>Address</TableHead>
										<TableHead className="text-center">
											GLN
										</TableHead>
										<TableHead className="text-center">
											Latitude
										</TableHead>
										<TableHead className="text-center">
											Longitude
										</TableHead>
										<TableHead>Action</TableHead>
									</TableRow>
								</TableHeader>
								<TableBody>
									{clientLocations?.length > 0 ? (
										clientLocations.map((location, i) => (
											<TableRow key={location.gln || i}>
												<TableCell>
													{location.address}
												</TableCell>
												<TableCell className="text-center">
													{location.gln}
												</TableCell>
												<TableCell className="text-center">
													{location.latitude}
												</TableCell>
												<TableCell className="text-center">
													{location.longitude}
												</TableCell>
												<TableCell>
													<button
														onClick={() => handleOpen(location)}
														className="flex items-center gap-1 text-primary hover:underline"
													>
														<AiOutlineEdit /> edit
													</button>
												</TableCell>
											</TableRow>
										))
									) : (
										<TableRow>
											<TableCell colSpan={5}>
												<h1 className="text-center h-[20vh] place-content-center text-gray-500">
													{isSuperAdmin && clients.length === 0
														? "No clients available"
														: "NO LOCATIONS FOUND"}
												</h1>
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</section>
					)}
				</div>
			</div>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="max-w-xl">
					<DialogHeader>
						<DialogDescription>
							<LocationForm
								locationData={localLocation}
								isOnboarding={false}
								onComplete={handleComplete}
							/>
						</DialogDescription>
					</DialogHeader>
				</DialogContent>
			</Dialog>
		</section>
	);
}

export default ClientLocations;